import {api} from './api'
import {ApiResponse, UssdConfig} from '../types'

export const getUssdConfig = async (): Promise<UssdConfig[]> => {
    try {
        const response = await api.get<ApiResponse<UssdConfig[]>>('/api/admin/ussd')
        return response.data.data || []
    } catch (error) {
        console.error('Error fetching USSD config:', error)
        return []
    }
}

export const updateUssdConfig = async (code: string, value: string): Promise<boolean> => {
    try {
        const response = await api.post('/api/admin/ussd/update', {code, value})
        return response.data.success
    } catch (error) {
        console.error('Error updating USSD config:', error)
        return false
    }
}